import AdvanceTable from "components/common/advance-table/AdvanceTable";
import SubtleBadge from "components/common/SubtleBadge";
import { useAdvanceTable } from "hooks";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import React from "react";

export const PurposesTable = ({ purposes, title }) => {
  const formatID = (id) => `${id.slice(0, 12)}...`;
  const formatText = (text) => `${text.slice(0, 30)}...`;

  const columns = [
    {
      accessorKey: "id",
      header: "ID",
      cell: ({ getValue }) => formatID(getValue()),
      meta: {
        headerProps: { className: "text-900" },
      },
    },
    {
      accessorKey: "code",
      header: "Code",
      meta: {
        headerProps: { className: "text-900" },
      },
    },
    {
      accessorKey: "name",
      header: "Name",
      meta: {
        headerProps: { className: "text-900" },
      },
    },
    {
      accessorKey: "active",
      header: "Status",
      cell: ({ getValue }) => {
        const value = getValue();
        const type = value == true ? "success" : "secondary";
        const label = value == true ? "Active" : "Disabled";

        return (
          <SubtleBadge pill bg={type}>
            {label}
          </SubtleBadge>
        );
      },
      meta: {
        headerProps: { className: "text-900" },
        cellProps: { className: "fs-9" },
      },
    },
    {
      accessorKey: "description",
      header: "Description",
      cell: ({ getValue }) => formatText(getValue()),
      meta: {
        headerProps: { className: "text-900" },
      },
    },
  ];

  const table = useAdvanceTable({
    data: purposes || [],
    columns: columns,
    sortable: true,
    pagination: true,
    perPage: 10,
  });
  return (
    <>
      <h6 className="fw-bold text-sm">{title}</h6>
      {purposes && purposes.length > 0 ? (
        <AdvanceTableProvider {...table}>
          <AdvanceTable
            headerClassName="bg-200 text-nowrap align-middle"
            rowClassName="btn-reveal-trigger text-nowrap align-middle"
            tableProps={{
              bordered: true,
              striped: true,
              className: "fs-10 mb-0 overflow-hidden",
            }}
          />
        </AdvanceTableProvider>
      ) : (
        <div className="text-xs">
          No purposes found assigned to this application
        </div>
      )}
    </>
  );
};
